import { render, staticRenderFns } from "./Distribuicao.vue?vue&type=template&id=7ac03235&scoped=true&"
import script from "./Distribuicao.vue?vue&type=script&lang=js&"
export * from "./Distribuicao.vue?vue&type=script&lang=js&"
import style0 from "./Distribuicao.vue?vue&type=style&index=0&id=7ac03235&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac03235",
  null
  
)

export default component.exports